// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d-aPN","right":"styles_right__29brH"};